// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import CatalogPage from '@/pages/CatalogPage.vue';
import ProductCardPage from '@/pages/ProductCardPage.vue';
import DropOrderPage from '@/pages/DropOrderPage.vue'; 
import PaymentPage from '@/pages/PaymentPage.vue';
import ManagerSettingsPage from '@/pages/ManagerSettingsPage.vue';
import DropProfilePage from '@/pages/DropProfilePage.vue';
import DropManagerPage from '@/pages/DropManagerPage.vue';
import DropProfileSettingsPage from '@/pages/DropProfileSettingsPage.vue';
import PresenceManagementPage from '@/pages/PresenceManagmentPage.vue';
import BotSettingsPage from '@/pages/BotSettingsPage.vue';
import LabelsSettingsPage from '@/components/BotSettingsComponents/LabelsSettingsPage.vue';
import FromAbroadOrderDataPage from '@/pages/FromAbroadOrderDataPage.vue';

const routes = [
    { 
        path: '/',
        component: CatalogPage, 
    },
    {
        path: '/product/:id', // динамический параметр
        component: ProductCardPage,
        props: route => ({ productId: Number(route.params.id) })
    },
    {
        path: '/drop_order/:dropPrice/:retailPrice/:selectedSize:/:productName/:productPhoto/:batchId?',
        component: DropOrderPage,
        name: 'DropOrder',
        props: true,
    },
    {
        path: '/pay',
        component: PaymentPage,
        name: 'Payment',
        props: route => ({
             ...route.query,
             isDrop: route.query.isDrop === 'true',
             batchId: route.query.batchId ? Number(route.query.batchId) : null,
        }), // автоматически передаёт все query как props
    },
    {
        path: '/manager',
        name: 'DropManager',
        component: ManagerSettingsPage,
    },
    {
        path: '/profile',
        name: 'DropProfile',
        component: DropProfilePage,
    },
    {
        path: '/drop-management',
        component: DropManagerPage,
    },
    {
        path: '/drop-management/profile/:dropId',
        name: 'DropProfileSettingsPage',
        component: DropProfileSettingsPage,
        props: true,
    },
    {
        path: '/presence-management',
        component: PresenceManagementPage,
        name: 'PresenceManagementPage',
    },
    {
        path: '/bot-settings',
        component: BotSettingsPage,
        name: 'BotSettingsPage',
    },
    {
        path: '/bot-settings/labels',
        component: LabelsSettingsPage,
        name: 'LabelsSettingsPage',  
    },
    {
        path: '/from-abroad-order/:orderId',
        component: FromAbroadOrderDataPage,
        name: 'FromAbroadOrder',
        props: true
    }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
